module.exports = __webpack_public_path__ + "img/increment_arrow.dd9b1f12.svg";